import React, { useState } from 'react';
import User from '../../models/User'

const UserContext = React.createContext();

const UserProvider = (props) => {
  const value = props.value && props.value.is ? props.value : User(props.value)
  const [user, setUser] = useState(value)

  const setItem = (value) => {
    setUser(value && value.is ? value : User(value))
  }

  return (
    <UserContext.Provider value={[user, setItem]}>
      {props.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider}
